import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Divider,
  Input,
  List,
  Header,
  Segment,
  Menu
} from "semantic-ui-react";
import ReactTable from "react-table";
import request from "../../utils/request";

export const columns = [
  {
    accessor: d => (
      <div>
        <Button
          as={Link}
          to={`/software-signature/${d.id}`}
          icon="bar chart"
          primary
        />
      </div>
    ),
    id: "id",
    Header: "Action"
  },
  {
    accessor: "updated_at",
    Header: "Date"
  },
  {
    accessor: "final_md5",
    Header: "MD5 Signature"
  },
  {
    accessor: "final_sha256",
    Header: "SHA256 Signature"
  },
  {
    accessor: d => (+d.failed === 0 ? "Pass" : "Fail"),
    id: "failed",
    Header: "Status"
  }
];

class SignatureList extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.state = {
      isLoading: true,
      sort: [{ id: "updated_at", desc: true }],
      data: [],
      signature: {},
      query: "",
      limit: 20,
      page: 1,
      total: 0
    };
  }
  componentDidMount = () => {
    this._mounted = true;

    // Fetch the initial data
    this.fetchData();

    request.list(this, "api:/signature", { limit: 1, sort: [{ id: "updated_at", desc: true }] }).then(resp => {
      this.setState({
        signature: resp.data[0]
      });
    });
  };
  fetchData = e => {
    this.setState({ isLoading: true });
    request
      .list(this, "api:/signature", {
        sort: this.state.sort,
        q: this.state.query,
        page: this.state.page,
        limit: this.state.limit
      })
      .then(resp => {
        this.setState({
          isLoading: false,
          data: resp.data,
          total: Math.ceil(resp.total / this.state.limit)
        });
      });
  };
  handleChange = (e, { name, value }) => {
    this.setState({ query: value });
  };
  handleKeyPress = e => {
    if (e.key === "Enter") {
      this.fetchData();
    }
  };
  handleGenerate = () => {
    this.setState({ isLoading: true });
    request
      .post(this, "api:/signature", {})
      .then(resp => {
        this.setState({
          isLoading: false,
        },this.fetchData);
      });
  }
  render() {
    const { data, limit, signature, total, isLoading } = this.state;
    return (
      <Segment basic>
        {signature && signature.updated_at && (
          <Segment inverted>
            <Header as="h3">Most recent signature</Header>
            <List divided inverted relaxed>
              <List.Item>
                <List.Content floated="right">
                  {signature.updated_at}
                </List.Content>
                <List.Header>Date Recorded</List.Header>
              </List.Item>
              <List.Item>
                <List.Content floated="right">
                  {signature.final_md5}
                </List.Content>
                <List.Header>MD5 Signature</List.Header>
              </List.Item>
              <List.Item>
                <List.Content floated="right">
                  {signature.final_sha256}
                </List.Content>
                <List.Header>SHA256 Signature</List.Header>
              </List.Item>
            </List>
          </Segment>
        )}
        <Menu secondary stackable>
          <Menu.Item>
            <Input
              icon="search"
              iconPosition="left"
              action={<Button content="Search" onClick={this.handleSearch} />}
              placeholder="Search..."
              onChange={this.handleChange}
              onKeyPress={this.handleKeyPress}
            />
          </Menu.Item>
          <Menu.Menu position='right'>
            <Menu.Item>
              <Button
                icon="key"
                content="Generate Signature"
                primary
                fluid
                onClick={this.handleGenerate}
              />
            </Menu.Item>
          </Menu.Menu>
        </Menu>
        <Divider hidden />
        <ReactTable
          data={data}
          columns={columns}
          className="-striped -highlight"
          manual
          pages={total} // Display the total number of pages
          loading={isLoading} // Display the loading overlay when we need it
          onPageChange={page => this.setState({ page: page + 1 }, this.fetchData)}
          onPageSizeChange={(limit, page) => this.setState({ limit, page }, this.fetchData)}
          onSortedChange={(newSorted, column, shiftKey) => {
            const sort = newSorted.map(sortObj => ({
              id: sortObj.id,
              desc: sortObj.desc
            }));

            this.setState({ sort }, this.fetchData);
          }}
          resizable={false}
          filterable={false}
          defaultPageSize={limit}
          minRows={0}
        />
      </Segment>
    );
  }
}

export default SignatureList;
